
export const Environment = process.env.NODE_ENV || 'development';
export const PlayStoreURL = "https://play.google.com/store/apps/details?id=com.fiveonetwo.boggle";
export const AppStoreURL = "https://apps.apple.com/us/app/play-pals-word-bobble/id1594090339";
export const FacebookURL = 'https://www.facebook.com/512Games';
export const TwitterURL = 'https://twitter.com/512Games';
export const InstagramURL = 'https://www.instagram.com/fiveonetwogames';
